import React from 'react'
import BinTransitKanbanView from '../../../components/Comman/BinTransitView/BinTransitKanbanView'
import { useNavigate } from 'react-router';

const ViewBinTransitPage = () => {
    const navigate = useNavigate();

    const handleArrowClick = () => {
        navigate(-1);
    };

  return (
    <BinTransitKanbanView handleArrowClick={handleArrowClick} />
  )
}

export default ViewBinTransitPage